import React from 'react';
import { Toolbar, SaveButton, TextInput, PasswordInput,
    required, useTranslate } from 'react-admin';
import { Typography, Box } from '@material-ui/core';

export const validatePasswords = ({
    password,
    password_confirm}) => {
  const errors = {};

  if ((password || password_confirm) && password !== password_confirm) {
      errors.password_confirm = [
          'resources.errors.password_mismatch',
      ];
  }

  return errors;
};

export const SectionTitle = ({ label }) => {
  const translate = useTranslate();

  return (
      <Typography variant="h6" gutterBottom>
          {translate(label)}
      </Typography>
  );
};

export const Separator = (props) => <Box pt={props.pt || '1em'} />;

export const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton {...props} />
  </Toolbar>
);

const dateTimeFormat = new Intl.DateTimeFormat('ja-JP', {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
  hour12: false,
  timeZone: 'Asia/Tokyo' 
});
const formatDate = src => {
  const d = src && dateTimeFormat.format(new Date(src));
  return d;
};

const SystemInfo = ({ record, style }) => {
  const translate = useTranslate();

  return (
    <div style={style}>
      <Typography variant="subtitle1">{translate('resources.labels.system')}</Typography>
      <Typography variant="body2">
        ID: {record && record.id}
      </Typography>
      <Typography variant="body2">
        {translate('resources.labels.created_at')}: {record && formatDate(record.created_at)}
      </Typography>
      <Typography variant="body2">
        {translate('resources.labels.updated_at')}: {record && formatDate(record.updated_at)}
      </Typography>
      {record && record.deleted_at && (<Typography variant="body2">
        {translate('resources.labels.deleted_at')}: {formatDate(record.updated_at)}
      </Typography>)}
    </div>
  );
};

export const HistoryAside = ({ record }) => {
  const translate = useTranslate();

  return (
    <div style={{ width: 180, margin: '1em', position: 'relative' }}>
      <Typography variant="h6">{translate('resources.labels.history')}</Typography>
      <Typography variant="body2">
        {translate('resources.labels.first_login')}: {record && formatDate(record.first_login)}
      </Typography>
      <Typography variant="body2">
        {translate('resources.labels.last_login')}: {record && formatDate(record.last_login)}
      </Typography>
      <SystemInfo record={record} style={{ position: 'absolute', bottom: '70px' }}/>
    </div>
  );
};

export const EditAside = ({ record }) => {
  return (
    <div style={{ width: 180, margin: '1em', position: 'relative' }}>
      <SystemInfo record={record} style={{ position: 'absolute', bottom: '70px' }}/>
    </div>
  );
};

export const NameInput = props => {
  const translate = useTranslate();
  const inputProps = {
    validate: [required()],
    style: { width: '100%' },
    ...props
  }

  return (
    <Box display={{ xs: 'block', sm: 'flex' }} style={{ width: '100%' }}>
      <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="last_name"
          label={translate(`resources.${props.resource}.fields.last_name`)}
          {...inputProps}
        />
      </Box>
      <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <TextInput source="first_name"
          label={translate(`resources.${props.resource}.fields.first_name`)}
          {...inputProps}
        />
      </Box>
    </Box>
  );
};

export const PasswordInputWithConfirm = props => {
  const translate = useTranslate();
  const inputProps = {
    style: { width: '100%' },
    ...props
  }

  return (
    <Box display={{ xs: 'block', sm: 'flex' }} style={{ width: '100%' }}>
      <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <PasswordInput source="password"
          label={translate(`resources.${props.resource}.fields.password`)}
          {...inputProps}
        />
      </Box>
      <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
        <PasswordInput source="password_confirm" 
          label={translate(`resources.${props.resource}.fields.password_confirm`)}
          {...inputProps}
        />
      </Box>
    </Box>
  );
};
